import React from 'react';
import { useSelector } from 'react-redux';
import PhysicianCardView from 'src/common/components/PhysicianCardView/PhysicianCardView';
import AdditionalProcedureData from 'src/common/components/additionalProcedure/AdditionalProcedureData';
import DeformityCorrectionCard from 'src/common/components/deformityCorrection/DeformityCorrection';
import PhysicianFinderCard from 'src/common/components/physicianFinder/PhysicianFinderEligibility';
import BiologicsUsedCard from 'src/common/components/biologicsUsed/BiologicsUsedCard';
import { TitleComponent } from '../../utils/reportUsage.styled';
import styled from 'styled-components';
import media, { sizes } from 'src/styles/Media.styled';
import RetractorUsedCard from 'src/common/components/retractorUsed/RetractorUsed';
import LevelProcedureCard from 'src/common/components/levelProcedure/LevelProcedure';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import { useTranslation } from 'react-i18next';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import { reorderMazorX } from 'src/utils/util';

const ProcedureViewContainerDesktop = ({
    procedureInfoData,
    procedureData,
    setProcedureInfoData,
    radioButtonChangeHandler,
    mazorxChecked,
    advancedEnergyCheck,
    advanceEnergyProduct,
    mazorRoboticsCode,
    mazorCodeValidator,
    mazorCodeValidatorOnBlur,
    validateMazorCodeRes,
    checkboxSelectionChangeHandler,
    handleInputChange,
    retractorUsedOtherFieldValue,
    textAreaCharLimit,
    charCountLimit,
    showBiologisDetails,
    setDropDownValue,
    dropDownValue,
    selectedPhysicianData,
    setSelectedPhysicianData,
    setPhysicianInputValue,
    physicianInputValue,
    proceduresList,
    showProcedureDropdown,
    isNoUsageToReport,
    procedureDataPhysician,
    countryCode,
    setMazorCaseCoverageInputValue,
    mazorCaseCoverageInputValue,
    selectedMazorCaseCoverage,
    setSelectedMazorCaseCoverage,
    noUsageToReportMycaseRefId,
    progressBarClicked,
    procedureValue,
    reportUsageObject,
    isProcedureReqConfig,
    isDraft,
    procedureDataPhysicianVisibility,
    procedureMandatoryRule,
    isFromProcedure,
    isPediatricSurgery,
    setPediatricCheck,
    isDisabledPediatric,
    pediatricMandatoryRule,
    pediatricSurgeryVisibility,
    pediatricValue,
    stealthAxisChecked,
    stealthAxisCode,
    setStealthAxisCode,
    stealthAxisAutoPilot,
    setStealthAxisAutoPilot,
    stealthAxisLiveAlign,
    setStealthAxisLiveAlign,
    setStealthAxisCaseCoverageInputValue,
    stealthAxisCaseCoverageInputValue,
    setSelectedStealthAxisCaseCoverage,
    selectedStealthAxisCaseCoverage,
    stealthCodeValidatorOnBlur,
    setStealthAxisCodeError,
    stealthAxisCodeError,
    reportUsageStealthLiveAlignVisibility,
    reportUsageStealthAutoPilotVisibility,
    physicianFieldText,
    setPhysicianFieldText,
    physicianTextBoxType,
    setPhysicianTextBoxType,
    isReportUsageFlow,
}) => {
    const { bannerHeight } = useSelector((state) => state.loginReducer);
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    const procedureDataLoading = useSelector(
        (state) => state.reportUsageRootReducer?.procedureDataLoading
    );
    const { t } = useTranslation();

    const {
        physicianDropdownZGReportUsageVisibility,
        physicianDropdownZGReportUsageMandatory,
        physicianTextUsageVisibility,
        physicianTextUsageMandatory,
    } = useSelector((state) => state.loginReducer); //changes
    const showSection =
        showProcedureDropdown && procedureMandatoryRule
            ? !procedureInfoData?.procedureConfigFlag
            : true;
       const INITIAL_FIELD_ORDER =
           window.innerWidth <= sizes.mobileDevice ||
           (window.innerWidth >= sizes.smalDevice &&
               window.innerWidth <= sizes.mediumDevice)
               ? [
                     'Powerease',
                     'Stealth S7/S8 Navigation',
                     'Stealth AXiS',
                     'Advanced Energy',
                     'MazorX Robot Used',
                 ]
               : [
                     'Powerease',
                     'Advanced Energy',
                     'Stealth S7/S8 Navigation',
                     'MazorX Robot Used',
                     'Stealth AXiS',
                 ];
        
        const FIELD_ORDER =
            window.innerWidth <= sizes.mobileDevice
                ? INITIAL_FIELD_ORDER
                : procedureInfoData?.additionalProcedure &&
                  Object.keys(procedureInfoData?.additionalProcedure).length >
                      0 &&
                  reorderMazorX(
                      INITIAL_FIELD_ORDER,
                      procedureInfoData?.additionalProcedure
                  );
    return (
        <>
            {!isNoUsageToReport && (
                <TitleComponent>
                    {t(
                        'reportUsage.procedure.ProcedureViewContainer.procedureData'
                    )}
                </TitleComponent>
            )}
            {procedureDataLoading ? (
                <Spinner id="reportUsage-procedureViewContainer-procedureDataLoadingSpinner" animation="border" variant="primary" small />
            ) : (
                procedureInfoData &&
                Object.keys(procedureInfoData).length > 0 && (
                    <ProcedureContainer
                        isNoUsageToReport={!isNoUsageToReport}
                        bannerHeight={bannerHeight}
                    >
                        {showProcedureDropdown ||
                        procedureDataPhysicianVisibility ||
                        pediatricSurgeryVisibility ||
                        physicianTextUsageVisibility === 'VISIBLE' ? (
                            <PhysicianCardView
                                showProcedureDropdown={showProcedureDropdown}
                                setDropDownValue={setDropDownValue}
                                dropDownValue={dropDownValue}
                                proceduresList={proceduresList}
                                setPhysicianInputValue={setPhysicianInputValue}
                                physicianInputValue={physicianInputValue}
                                selectedPhysicianData={selectedPhysicianData}
                                setSelectedPhysicianData={
                                    setSelectedPhysicianData
                                }
                                countryCode={countryCode}
                                procedureValue={procedureValue}
                                reportUsageObject={reportUsageObject}
                                marginBottom={
                                    window.innerWidth < sizes.mobileDevice &&
                                    !procedureValue
                                        ? '5px'
                                        : window.innerWidth >
                                              sizes.mobileDevice && '10px'
                                }
                                ProcedureMarginBottom={'57px'}
                                isProcedureReqConfig={isProcedureReqConfig}
                                isDraft={isDraft}
                                procedureDataPhysicianVisibility={
                                    procedureDataPhysicianVisibility
                                }
                                procedureMandatoryRule={procedureMandatoryRule}
                                isDisabledPediatric={isDisabledPediatric}
                                setPediatricCheck={setPediatricCheck}
                                isPediatricSurgery={isPediatricSurgery}
                                isFromProcedure={isFromProcedure}
                                pediatricMandatoryRule={pediatricMandatoryRule}
                                pediatricSurgeryVisibility={
                                    pediatricSurgeryVisibility
                                }
                                pediatricValue={pediatricValue}
                                physicianTextUsageVisibility={
                                    physicianTextUsageVisibility
                                }
                                physicianTextUsageMandatory={
                                    physicianTextUsageMandatory
                                }
                                physicianFieldText={physicianFieldText}
                                setPhysicianFieldText={setPhysicianFieldText}
                                physicianTextBoxType={physicianTextBoxType}
                                setPhysicianTextBoxType={setPhysicianTextBoxType}
                                isReportUsageFlow={isReportUsageFlow}
                            />
                        ) : null}

                        {!(
                            procedureInfoData.levels?.[0] ===
                            'ADDITIONAL_PROCEDURE_DATA'
                        ) &&
                            procedureInfoData?.levels && (
                                <LevelProcedureCard
                                    levelsData={procedureInfoData?.levels}
                                    procedureInfoData={procedureInfoData}
                                    setProcedureInfoData={setProcedureInfoData}
                                />
                            )}
                        {showSection &&
                            procedureInfoData?.additionalProcedure &&
                            Array.isArray(
                                procedureInfoData.additionalProcedure
                            ) &&
                            procedureInfoData.additionalProcedure.length > 0 &&
                            procedureInfoData.additionalProcedure?.[0] !==
                                'ADDITIONAL_PROCEDURE_DATA' && (
                                <AdditionalProcedureData
                                    additionalProcedureData={
                                        procedureInfoData?.additionalProcedure
                                    }
                                    procedureData={procedureData}
                                    progressBarClicked={progressBarClicked}
                                    procedureInfoData={procedureInfoData}
                                    setProcedureInfoData={setProcedureInfoData}
                                    radioButtonChangeHandler={
                                        radioButtonChangeHandler
                                    }
                                    mazorxChecked={mazorxChecked}
                                    advancedEnergyCheck={advancedEnergyCheck}
                                    advanceEnergyProduct={advanceEnergyProduct}
                                    mazorRoboticsCode={mazorRoboticsCode}
                                    mazorCodeValidator={mazorCodeValidator}
                                    mazorCodeValidatorOnBlur={
                                        mazorCodeValidatorOnBlur
                                    }
                                    validateMazorCodeRes={validateMazorCodeRes}
                                    checkboxSelectionChangeHandler={
                                        checkboxSelectionChangeHandler
                                    }
                                    setMazorCaseCoverageInputValue={
                                        setMazorCaseCoverageInputValue
                                    }
                                    mazorCaseCoverageInputValue={
                                        mazorCaseCoverageInputValue
                                    }
                                    setSelectedMazorCaseCoverage={
                                        setSelectedMazorCaseCoverage
                                    }
                                    selectedMazorCaseCoverage={
                                        selectedMazorCaseCoverage
                                    }
                                    noUsageToReportMycaseRefId={
                                        noUsageToReportMycaseRefId
                                    }
                                    condensedViewPadding={
                                        isCondensedView && '30px'
                                    }
                                    stealthAxisChecked={stealthAxisChecked}
                                    stealthAxisCode={stealthAxisCode}
                                    setStealthAxisCode={setStealthAxisCode}
                                    stealthAxisAutoPilot={stealthAxisAutoPilot}
                                    setStealthAxisAutoPilot={
                                        setStealthAxisAutoPilot
                                    }
                                    stealthAxisLiveAlign={stealthAxisLiveAlign}
                                    setStealthAxisLiveAlign={
                                        setStealthAxisLiveAlign
                                    }
                                    setStealthAxisCaseCoverageInputValue={
                                        setStealthAxisCaseCoverageInputValue
                                    }
                                    stealthAxisCaseCoverageInputValue={
                                        stealthAxisCaseCoverageInputValue
                                    }
                                    setSelectedStealthAxisCaseCoverage={
                                        setSelectedStealthAxisCaseCoverage
                                    }
                                    selectedStealthAxisCaseCoverage={
                                        selectedStealthAxisCaseCoverage
                                    }
                                    stealthCodeValidatorOnBlur={
                                        stealthCodeValidatorOnBlur
                                    }
                                    stealthAxisCodeError={stealthAxisCodeError}
                                    setStealthAxisCodeError={
                                        setStealthAxisCodeError
                                    }
                                    FIELD_ORDER={FIELD_ORDER}
                                    reportUsageStealthAutoPilotVisibility={reportUsageStealthAutoPilotVisibility}
                                    reportUsageStealthLiveAlignVisibility={reportUsageStealthLiveAlignVisibility}
  
                                />
                            )}
                        {!(
                            procedureInfoData?.therapies?.[0] ===
                            'ADDITIONAL_PROCEDURE_DATA'
                        ) &&
                            procedureInfoData.therapies &&
                            showSection && (
                                <PhysicianFinderCard
                                    physicianFinderData={
                                        procedureInfoData.therapies
                                    }
                                    checkboxSelectionChangeHandler={
                                        checkboxSelectionChangeHandler
                                    }
                                />
                            )}
                        {!(
                            procedureInfoData?.retractors?.[0] ===
                            'ADDITIONAL_PROCEDURE_DATA'
                        ) &&
                            showSection &&
                            procedureInfoData?.retractors && (
                                <RetractorUsedCard
                                    retractorUsedData={
                                        procedureInfoData.retractors
                                    }
                                    checkboxSelectionChangeHandler={
                                        checkboxSelectionChangeHandler
                                    }
                                    handleInputChange={handleInputChange}
                                    retractorUsedOtherFieldValue={
                                        retractorUsedOtherFieldValue
                                    }
                                    textAreaCharLimit={textAreaCharLimit}
                                    charCountLimit={charCountLimit}
                                />
                            )}
                        {!(
                            procedureInfoData?.technologies?.[0] ===
                            'ADDITIONAL_PROCEDURE_DATA'
                        ) &&
                            procedureInfoData.technologies &&
                            showSection && (
                                <DeformityCorrectionCard
                                    deformityTechnologiesData={
                                        procedureInfoData.technologies
                                    }
                                    radioButtonChangeHandler={
                                        radioButtonChangeHandler
                                    }
                                />
                            )}
                        {!(
                            procedureInfoData?.biologicsUsed?.[0] ===
                            'ADDITIONAL_PROCEDURE_DATA'
                        ) &&
                            procedureInfoData.biologicsUsed &&
                            showSection && (
                                <BiologicsUsedCard
                                    biologicsUsedData={
                                        procedureInfoData.biologicsUsed
                                    }
                                    biologicsDetailData={
                                        procedureInfoData.biologicsDetail
                                    }
                                    showBiologisDetails={showBiologisDetails}
                                    checkboxSelectionChangeHandler={
                                        checkboxSelectionChangeHandler
                                    }
                                />
                            )}
                    </ProcedureContainer>
                )
            )}
        </>
    );
};

export default ProcedureViewContainerDesktop;

export const ProcedureContainer = styled.div`
    ${media.mobileDevice`
        margin-bottom : ${({ isNoUsageToReport, bannerHeight }) =>
            !isNoUsageToReport
                ? bannerHeight
                    ? `${bannerHeight}`
                    : '40%'
                : 'unset'};
    `};
`;
